import { useState, useEffect, useCallback, useRef } from 'react';
import api from '../services/api';

// Task 26 — PM ayarları (Task 1'de tanımlanan flag'ler: GoalRevisionEnabled,
// CascadingGoalsEnabled, HrGoalApprovalEnabled, vb.) için basit fetch+cache hook.
// GET /v1/performance-settings sık değişmeyen, tüm tenant için tek bir kayıt
// döndürür — modül-seviyeli bellek-içi önbellek (TTL/invalidation yok) birden
// çok bileşenin aynı isteği tekrar tekrar atmasını önler. Sonraki FE görevleri
// (Task 27+) de bu hook'u tüketecek (brief'te belirtilen "erken buraya yazılır"
// kararı).
let cache = null;
let inflight = null;

const fetchSettings = () => {
  if (cache) return Promise.resolve(cache);
  if (inflight) return inflight;

  inflight = api.get('/v1/performance-settings')
    .then((res) => {
      cache = res.data?.data || null;
      inflight = null;
      return cache;
    })
    .catch((err) => {
      inflight = null;
      throw err;
    });

  return inflight;
};

export default function usePerformanceSettings() {
  const [settings, setSettings] = useState(cache);
  const [loading, setLoading] = useState(!cache);
  const mountedRef = useRef(true);

  useEffect(() => {
    mountedRef.current = true;
    return () => { mountedRef.current = false; };
  }, []);

  useEffect(() => {
    if (cache) {
      setSettings(cache);
      setLoading(false);
      return;
    }
    setLoading(true);
    fetchSettings()
      .then((data) => { if (mountedRef.current) setSettings(data); })
      .catch(() => {})
      .finally(() => { if (mountedRef.current) setLoading(false); });
  }, []);

  // Ayarlar başka bir sayfada (ör. Task 1'in konfigürasyon ekranı) değiştirildiyse
  // önbelleği temizleyip yeniden çeker.
  const refresh = useCallback(() => {
    cache = null;
    setLoading(true);
    return fetchSettings()
      .then((data) => { if (mountedRef.current) setSettings(data); return data; })
      .catch(() => null)
      .finally(() => { if (mountedRef.current) setLoading(false); });
  }, []);

  return { settings, loading, refresh };
}
